import React, { useEffect, useRef, useState } from 'react';

/**
 * Shows lowSrc immediately, then swaps to highSrc once highSrc has finished preloading in the
 * background - only starts that preload once `loadHighRes` becomes true. The <img> itself never
 * changes size (callers give it a fixed width/height + object-fit via CSS), so the swap is
 * invisible beyond a sharpness change.
 */
const ProgressiveImage = ({ lowSrc, highSrc, loadHighRes, alt, className, onClick }) => {
  const resolvedHigh = highSrc || lowSrc;
  const [currentSrc, setCurrentSrc] = useState(lowSrc || resolvedHigh);
  const loadedHighRef = useRef(null);

  useEffect(() => {
    // A different image identity (e.g. poster was changed) - reset to its low-res placeholder.
    if (loadedHighRef.current !== resolvedHigh) {
      setCurrentSrc(lowSrc || resolvedHigh);
    }
  }, [lowSrc, resolvedHigh]);

  useEffect(() => {
    if (!loadHighRes || !resolvedHigh || loadedHighRef.current === resolvedHigh) return undefined;
    let cancelled = false;
    const img = new window.Image();
    img.onload = () => {
      if (cancelled) return;
      loadedHighRef.current = resolvedHigh;
      setCurrentSrc(resolvedHigh);
    };
    img.src = resolvedHigh;
    return () => { cancelled = true; };
  }, [loadHighRes, resolvedHigh]);

  return (
    <img src={currentSrc} alt={alt} className={className} onClick={onClick} />
  );
};

export default ProgressiveImage;
